import { HTMLAttributes, ReactNode, forwardRef } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
    },
  });

export interface BodyProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'classes'>,
    WithStyles<typeof styles> {
  children: ReactNode;
}

const Body = forwardRef<HTMLDivElement, BodyProps>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <div ref={ref} className={classNames(classes.root, className)} {...rest}>
      {children}
    </div>
  );
});

Body.displayName = 'ActivityFeedItem.Body';

export default withStyles(styles)(Body);
